import { Box, Typography, Link } from '@mui/material';
import { styled } from '@mui/material/styles';

const PREFIX = 'LabelLink';

const classes = {
  container: `${PREFIX}-container`,
  label: `${PREFIX}-label`,
  link: `${PREFIX}-link`,
};

const StyledBox = styled(Box)(({ theme }) => ({
  [`&.${classes.container}`]: {
    display: 'flex',
    flexDirection: 'column',
  },

  [`& .${classes.label}`]: {
    fontWeight: 300,
  },

  [`& .${classes.link}`]: {
    fontWeight: 500,
    wordBreak: 'break-word',
  },
}));

interface LabelLinkProps {
  label: string;
  value: string | undefined;
  link: string;
  underline?: 'none' | 'always' | 'hover' | undefined;
}

export default function LabelLink({
  label,
  value,
  link,
  underline = 'hover',
}: LabelLinkProps) {
  return (
    <StyledBox component="div">
      <Box component="div" className={classes.container}>
        <Typography component="div" className={classes.label}>
          {label}
        </Typography>
        <Link
          href={link}
          data-testid="labelLink"
          className={classes.link}
          color="textPrimary"
          underline={underline}>
          {value}
        </Link>
      </Box>
    </StyledBox>
  );
}
